import React from 'react';
export function GrainOverlay() {
  return <div className="pointer-events-none fixed inset-0 z-50 h-full w-full opacity-[0.15] mix-blend-overlay" data-id="element-180">
      <svg className="absolute inset-0 h-full w-full" data-id="element-181">
        <filter id="noiseFilter" data-id="element-182">
          <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" stitchTiles="stitch" data-id="element-183" />
        </filter>
        <rect width="100%" height="100%" filter="url(#noiseFilter)" data-id="element-184" />
      </svg>
    </div>;
}